import axios from 'axios';
import { currentToken } from '~/common/auth';
import qs from 'qs';
import moment from 'moment';

const dateFormat = 'YYYY-MM-DD';

const requestHeaders = () => {
  return currentToken()
    .then(token => {
      let header = {
        'content-type': 'application/json',
        authorization: 'Bearer ' + token,
      };

      return header;
    })
    .catch(err => {
      if (err.code === 'NotAuthorizedException') {
        console.log(err);
      }
    });
};

const SleepJournalService = {
  async fetchJournals(id, startDate, endDate) {
    const param = {
      startDate: startDate,
      endDate: endDate,
    };

    const headers = await requestHeaders();
    try {
      const { data } = await axios.get(
        `${process.env.NALURI_APP_HEALTHKIT_URL}/journals/sleep/member/${id}?${qs.stringify(
          param,
        )}`,
        {
          headers,
        },
      );

      return data;
    } catch (err) {
      console.error(err);
      return;
    }
  },

  async getSleepSchedule(id) {
    const headers = await requestHeaders();
    const body = {
      memberId: id,
    };

    try {
      const {
        data,
      } = await axios.post(
        `${process.env.NALURI_APP_HEALTHKIT_URL}/journals/sleep/getSleepSchedule`,
        JSON.stringify(body),
        { headers },
      );

      return data.schedule;
    } catch (err) {
      console.error(err);
      return;
    }
  },

  async getSleepMetrics(id, startDate, endDate) {
    const headers = await requestHeaders();
    const body = {
      memberId: id,
      startDate: moment(startDate)
        .subtract(2, 'days')
        .subtract(2, 'weeks')
        .format(dateFormat),
      endDate: moment(endDate)
        .subtract(2, 'days')
        .format(dateFormat),
    };

    try {
      const {
        data,
      } = await axios.post(
        `${process.env.NALURI_APP_HEALTHKIT_URL}/journals/sleep/getMemberSleepMetrics`,
        JSON.stringify(body),
        { headers },
      );

      return data;
    } catch (err) {
      console.error(err);
      return;
    }
  },
};

export default SleepJournalService;



// WEBPACK FOOTER //
// ./src/features/sleep-journal/services/SleepJournalService.js